const Paths = {
  Home: "/",
  About: "/about",
  MenuBottomTransition: "/menu-bottom-transition",
  InfiniteRandomTiles: "/infinite-random-tiles",
  GoogleCustomSearch: "/google-custom-search",
  ImageGrid: "/image-grid",
  NotFound: "404",
};

export default Paths;
